import { Component, Prop } from 'vue-property-decorator';
import { AbstractWidgetContent } from '@/components/Dashboard/Widgets/AbstractWidget/AbstractWidget';
import { WidgetConfigBulkShipmentProgressStatus, WidgetData } from '@/components/Dashboard/Widgets/types/Widget';

@Component({
    components: {
    }
})
export default class WidgetContentBulkShipmentProgressStatusPart extends AbstractWidgetContent<WidgetConfigBulkShipmentProgressStatus> {
    @Prop()
    public config!: WidgetConfigBulkShipmentProgressStatus;
    private count = 0;
    private amount = 0;
    private label = '円';
    private quantity = 0;
    private unitSet = true;

    created(): void {
        this.getWidgetData()
    }

    refresh(widgetData: WidgetData): void {
        this.count = 0;
        this.amount = 0;
        this.label = '円';
        this.quantity = 0;
        this.unitSet = true;
        if (typeof widgetData == 'object') {
            this.$set(this.config, 'unit', widgetData.config.unit)
        }
        this.getWidgetData()
    }

    private getWidgetData() {
        this.label = this.config.unit.label;
        const unitMultiplier = this.config.unit.value;
        this.$apiClient.doRequest('get', '/admin/bulk_shipment_progress_status').then((res) => {
            this.count = res.count;
            this.amount = +(res.amount / unitMultiplier).toFixed(2);
            this.quantity = +res.quantity.toFixed(2);
            this.unitSet = res.unitSet;
        })
    }

    private changeNumberFormat(value: number): string | null {
        return Math.round(value).toLocaleString("ja-JP");
    }
}